import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Button, Col, Row } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import { BroadcastLauncherTypes } from "../../app/models/broadcast";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface IProps {
    toggle: () => void;
}

const BroadcastUserChoiseForm = ({
    toggle,
  }: IProps) => {
    const rootStore = useContext(RootStoreContext);
    const { updateLauncherMode } = rootStore.broadcastStore;
    const { theme } = rootStore.commonStore;
    const [t] = useTranslation(["translation"], translationHookOptions);

    const handleJoinWithOpenVidu = () => {
        updateLauncherMode(BroadcastLauncherTypes.onlyOpenVidu);
        toggle();
    }
    const handleJoinWithExternalSystem = () => {
        updateLauncherMode(BroadcastLauncherTypes.onlyExternalSystem);
        toggle();
    }
  
    return (
      <div>
        <Row>
            <Col style={{display: "flex", justifyContent: "center"}}>
                <Button
                style={{fontSize: "0.8rem"}}
                    className={classNames(
                        "genericButton",`${theme?.headerColor} ${theme?.headerTextColor}`
                    )}
                    onClick={handleJoinWithOpenVidu}
                >
                    {"TELETABBER STREAMING"}
                </Button>
            </Col>
            <Col style={{display: "flex", justifyContent: "center"}}>
                <Button
                style={{fontSize: "0.8rem"}}
                className={classNames(
                    "genericButton",
                    `${theme!.buttonSecondaryColor} ${
                      theme!.buttonSecondaryBorderColor
                    } ${theme!.buttonSecondaryTextColor}`
                  )}
                    onClick={handleJoinWithExternalSystem}
                >
                    {t("externalPlatform")}
                </Button>
            </Col>
        </Row>
      </div>
    );
  };
  
  export default observer(BroadcastUserChoiseForm);